// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608261156/js/" + chunkId + "." + {"44":"ce9e3da3","225":"edab48ad","481":"ca7afcf3","486":"f1ca4aa4","770":"227d2568"}[chunkId] + ".0.9165880557845625.chunk.js";
};